<template>
  <div class="content_main">
    <div class="content_main_top">
        <a-select show-search allowClear placeholder="公司" class="margin_self" @change="handlecompany" v-model="queryParam.companyId"
            @keyup.enter.native="query" style="width: 160px">
            <a-select-option :value="item.deptId" v-for="(item, index) in companylist" :key="index">
                {{ item.title }}
            </a-select-option>
        </a-select>
        <a-tree-select allowClear :treeData="deptTree2" v-model="queryParam.deptId" :disabled="!queryParam.companyId" placeholder="部门" @keyup.enter.native="query"
            @change="handledept" style="width: 160px" class="margin_self" treeDefaultExpandAll>
        </a-tree-select>
      <a-range-picker valueFormat="YYYY-MM-DD" style="margin-right: 10px; width: 240px" allowClear :value="dates"
        @change="onChange" @keyup.enter.native="query" :placeholder="['开始时间', '结束时间']" />
      <a-input allowClear  class="a_input_self margin_self"  v-model="queryParam.userName"  placeholder="用户"  @keyup.enter.native="query"/>
      <a-button type="primary" @click="query"> 查询 </a-button>
      <a-button type="primary" ghost @click="result"> 重置 </a-button>
      <a-button type="primary" @click="exp"> 数据导出 </a-button>

    </div>
    <div class="content_main_center" id="content_main_center">
      <a-table :data-source="lis" bordered :loading="loading" :pagination="false" @change="handleTableChange" 
        :scroll="{ y: scroll_y, x: 3000, scrollToFirstRowOnChange: true }">
        <a-table-column key="index" title="序号" data-index="index" width="70px" fixed="left">
          <template scope="text, record, index">{{
              (pagination.current - 1) * pagination.pageSize + index + 1
          }}</template>
        </a-table-column>
        <a-table-column key="userName" title="姓名" ellipsis="true" data-index="userName" width="100px" fixed="left"/>
        <a-table-column key="rcbgFee" title="日常办公费用" ellipsis="true" data-index="rcbgFee" />
        <a-table-column key="deptbeiyongFee" title="备用金" ellipsis="true" data-index="deptbeiyongFee" />
        <a-table-column key="biaoshuFee" title="标书及报告" ellipsis="true" data-index="biaoshuFee" />
        <a-table-column key="payFee" title="差旅费" ellipsis="true" data-index="payFee" />
        <a-table-column key="cheliangFee" title="车辆费用" ellipsis="true" data-index="cheliangFee" />
        <a-table-column key="fukuaiFee" title="付款代收代付" ellipsis="true" data-index="fukuaiFee" />
        <a-table-column key="zulinFee" title="房屋租赁" ellipsis="true" data-index="zulinFee" />
        <a-table-column key="fenhongFee" title="分红" ellipsis="true" data-index="fenhongFee" />
        <a-table-column key="fuliFee" title="福利费" ellipsis="true" data-index="fuliFee" />
        <a-table-column key="guquanFee" title="股权转让个税缴纳" ellipsis="true" data-index="guquanFee" />
        <a-table-column key="caigouFee" title="固定资产采购" ellipsis="true" data-index="caigouFee" />
        <a-table-column key="huiwuFee" title="会务费" ellipsis="true" data-index="huiwuFee" />
        <a-table-column key="jiaotongFee" title="交通费" ellipsis="true" data-index="jiaotongFee" />
        <a-table-column key="jeiriwailianFee" title="节日招待费" ellipsis="true" data-index="jeiriwailianFee" />
        <a-table-column key="kuaidiFee" title="快递费" ellipsis="true" data-index="kuaidiFee" />
        <a-table-column key="peixunFee" title="培训费" ellipsis="true" data-index="peixunFee" />
        <a-table-column key="renshiFee" title="人事费用" ellipsis="true" data-index="renshiFee" />
        <a-table-column key="yajinFee" title="押金退款" ellipsis="true" data-index="yajinFee" />
        <a-table-column key="tuikuanFee" title="业务退款" ellipsis="true" data-index="tuikuanFee" />
        <a-table-column key="zhaodaiFee" title="业务招待费" ellipsis="true" data-index="zhaodaiFee" />
        <a-table-column key="yiqiFee" title="仪器费用" ellipsis="true" data-index="yiqiFee" />
        <a-table-column key="total" title="合计" ellipsis="true" data-index="total" />
        <!-- <a-table-column title="操作" width="180px">
          <template scope="text,record">
            <a @click="edit(record)">编辑</a>
            <a-divider type="vertical" />
          </template>
        </a-table-column> -->
      </a-table>
      <div class="pageBottom">
            <a-pagination v-model="pagination.current" show-size-changer :page-size.sync="pagination.pageSize"
                :total="pagination.total" @showSizeChange="onShowSizeChange"
                :pageSizeOptions="['10', '20', '30', '40', '50']" @change="onShowSizeChange" />
      </div>
    </div>
    
    <a-modal title="编辑" :visible="is_show_apply" @cancel="applyClose" @ok="handleOk" width="70%"
      :maskClosable="false">
      <a-form-model :model="form" ref="ruleForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-row>
            <a-col :span="8">
                <a-form-model-item label="用户" prop="userName">
                    <span>{{form.userName}}</span>
                    <!-- <a-input v-model="form.applyCode" disabled></a-input> -->
                </a-form-model-item>
            </a-col>
            <a-col :span="8">
                <a-form-model-item label="工资" prop="salary">
                    <!-- <span>{{form.salary}}</span> -->
                    <a-input v-model="form.salary" ></a-input>
                </a-form-model-item>
            </a-col>
            <a-col :span="8">
                <a-form-model-item label="报销" prop="subjectionDeptId">
                    <span>{{form.expense}}</span>
                    <!-- <a-input v-model="form.applyCode" disabled></a-input> -->
                </a-form-model-item>
            </a-col>
        </a-row>
        <a-row>
            <a-col :span="8">
                <a-form-model-item label="业务费" prop="businessFee">
                    <span>{{form.businessFee}}</span>
                    <!-- <a-input v-model="form.applyCode" disabled></a-input> -->
                </a-form-model-item>
            </a-col>
            <a-col :span="8">
                <a-form-model-item label="评审费" prop="reviewFee">
                    <span>{{form.reviewFee}}</span>
                    <!-- <a-input v-model="form.applyCode" disabled></a-input> -->
                </a-form-model-item>
            </a-col>
            <a-col :span="8">
                <a-form-model-item label="服务费" prop="serviceFee">
                    <span>{{form.serviceFee}}</span>
                    <!-- <a-input v-model="form.applyCode" disabled></a-input> -->
                </a-form-model-item>
            </a-col>
        </a-row>
        <a-row>
            <a-col :span="8">
                <a-form-model-item label="分包费" prop="businessFee">
                    <span>{{form.businessFee}}</span>
                    <!-- <a-input v-model="form.subFee" disabled></a-input> -->
                </a-form-model-item>
            </a-col>
            <a-col :span="8">
                <a-form-model-item label="绩效" prop="performance">
                    <!-- <span>{{form.reviewFee}}</span> -->
                    <a-input v-model="form.performance" ></a-input>
                </a-form-model-item>
            </a-col>
            <a-col :span="8">
                <a-form-model-item label="年终奖" prop="bonus">
                    <!-- <span>{{form.serviceFee}}</span> -->
                    <a-input v-model="form.bonus" ></a-input>
                </a-form-model-item>
            </a-col>
        </a-row>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { downLoadXlxs2 , downLoadXlxs4} from '@/utils/index'
import {tree_all} from '@/api/purchase'
import { getDeptListEnable2 } from '@/api/system'
import { getFinanceReimburseData, updateBizPersonalMoney , getFinanceReimburseDetailData} from '@/api/financial'
export default {
  data() {
    return {
      loading: false,
      deptTree: [],
      rules: {},
      scroll_y: 150,
      loading: false,
      lis: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showLessItems: true,
        showSizeChanger: true,
      },
      labelCol: {
        span: 9,
      },
      wrapperCol: {
        span: 15,
      },
      is_show_apply: false,
      form: {
        cc: [],
        reimbursementCode: '',
        reimburseType: undefined,
        associateApply: [],
        reimburseMoneyTotal: '',
        remark: '',
        remarkSpec: '',
        name: '',
        accountNum: '',
        bank: '',
        reimburseDetails: [
          {
            expenseTime: '',
            types: undefined,
            money: '',
            remark: '',
          },
        ],
      },
      queryParam: {
          userName: '',
          companyId: undefined,
          deptId: undefined,
          startTime: '',
          endTime: '',
          userName: '',
      },
      dates: [],
      companylist: [],
      loadData: [],
      deptTree2: [],
      deptlist: [],
    }
  },
  created() {
      tree_all().then((res) => {
            this.companylist = res.data[0]
        })
    this.get_lis()
  },
  mounted() {
    this.$nextTick(() => {
      var max_h = $('#content_main_center').height()
      setTimeout(() => {
        this.scroll_y = max_h - $('.ant-table-header').height() - 50
      }, 1000)
    })
  },
  methods: {
      //分页
        onShowSizeChange(current, pageSize) {
            this.pagination.current = current
            this.pagination.pageSize = pageSize;
            //改变完 重新渲染数据
            this.get_lis()
        },
       exp() {
        downLoadXlxs4(process.env.VUE_APP_API_BASE_URL + '/act/payment_apply/downloadFinanceReimburseDetailData',
            { 
                companyId: this.queryParam.companyId,
                deptId: this.queryParam.deptId,
                startTime: this.queryParam.start_date,
                endTime:  this.queryParam.end_date,
                pageSize: this.pagination.pageSize,
                pageNum: this.pagination.current,
                userName: this.queryParam.userName
             })
        },
        edit(data) {
            this.form = JSON.parse(JSON.stringify(data))
            this.is_show_apply = true
        },
        handlecompany(value) {
            this.deptTree2 = []
            this.deptlist = []
            this.queryParam.deptId = undefined
            this.$nextTick(() => {
                getDeptListEnable2().then((res) => {
                    const data = res.rows
                    if (data.length > 0) {
                        const min = Math.min(...data.map((m) => m.parentId))
                        this.buildtree2(data, this.deptTree2, this.queryParam.companyId)
                    }
                })
            })
        },
        handledept(value) {
            this.queryParam.deptId = value
        },
        handleTableChange(pagination) {
        this.pagination.current = pagination.current
        this.loading = true
        this.get_lis()
        },
        applyClose() {
            this.is_show_apply = false
            this.form = {}
        },
        buildtree2(list, arr, parentId) {
            list.forEach((item) => {
                if (item.parentId === parentId) {
                var child = {
                    key: item.deptId,
                    value: item.deptId, // value是给modal的select用的，2者属性不一样
                    title: item.deptName,
                    scopedSlots: {
                    title: 'title',
                    },
                    children: [],
                }
                this.buildtree2(list, child.children, item.deptId)
                if (child.children.length === 0) {
                    delete child.children
                }
                arr.push(child)
                }
            })
        },
        cancel() {
        
        },
        onChange(date, dateString) {
        this.dates = date
        this.queryParam.start_date = date[0]
        this.queryParam.end_date = date[1]
        },
        handleOk() {
            // 提交编辑弹窗
            updateBizPersonalMoney(this.form).then(res => {
                if(res.code == 200) {
                    //关闭弹窗
                    this.applyClose()
                    // 刷新列表
                    this.query()
                    this.$message.success(res.msg)
                } else {
                    this.$message.error(res.msg)
                }
            })
    
        // this.$refs.ruleForm.validate((valid) => {
        //     if (valid) {}
        // })
        },
        get_lis() {
            this.loading = true
            getFinanceReimburseDetailData({
                companyId: this.queryParam.companyId,
                deptId: this.queryParam.deptId,
                startTime: this.queryParam.start_date,
                endTime:  this.queryParam.end_date,
                pageSize: this.pagination.pageSize,
                pageNum: this.pagination.current,
                userName: this.queryParam.userName
            }).then(res => {
                if(res.code == 200) {
                    const pagination = { ...this.pagination }
                    pagination.total = res.total
                    this.pagination = pagination
                    this.lis = res.rows
                } else {
                    this.$message.error(res.msg)
                }
                this.loading = false
            })



        //   list_my({
        //     procDefKey: 'reimburse',
        //     pageSize: this.pagination.pageSize,
        //     pageNum: this.pagination.current,
        //     status: this.queryParam.status,
        //     result: this.queryParam.result,
        //     applyUserName: this.queryParam.applyUserName,
        //     purchaseCode: this.queryParam.purchaseCode,
        //     createTime1: this.queryParam.start_date,
        //     createTime2: this.queryParam.end_date,
        //     sortField: 'applyTime',
        //     sortOrder: 'desc',
        //   }).then((res) => {
        //     const pagination = { ...this.pagination }
        //     pagination.total = res.total
        //     this.pagination = pagination
        //     this.lis = res.rows
        //     this.loading = false
        //   })
        },
        query() {
        this.pagination.current = 1
        this.get_lis()
        },
        result() {
        this.queryParam = {
            userName: '',
            companyId: undefined,
            deptId: undefined,
            startTime: '',
            endTime: '',
        },
        this.dates = []
        },
    },
}
</script>

<style scoped lang='less'>
.pay_top {
  width: 100%;
  float: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.form_title {
  margin-left: 15px;
  margin-bottom: 15px;
  font-size: 17px;
  color: #999;
}

.close_icon {
  font-size: 20px;
  color: red;
  cursor: pointer;
}

.close_icon2 {
  font-size: 14px;
  color: red;
  cursor: pointer;
}

.auditItem {
  border-radius: 5px;
  background-color: #f8f8f8;
  margin-left: 10px;
  color: dodgerblue;
  padding: 10px;
}

.btn_last {
  width: 100%;
  float: left;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
}

.item_top {
  width: 100%;
  float: left;

  .item {
    float: left;
    margin-right: 20px;
    cursor: pointer;
  }
}

.item_box {
  width: 100%;
  float: left;

  .boxItem {
    width: 100%;
    float: left;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 8px;

    .select {
      width: calc(100% / 2);
    }

    .itemTitle {
      width: 88px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding-right: 8px;
      box-sizing: border-box;

      .must {
        color: red;
      }
    }
  }
}
.pageBottom {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
}
</style>
